app.component("progressNoteForm", {
	templateUrl: "app/src/js/components/progressNote/progressNoteForm.html",
	controller: "progressNoteFormController",
	bindings: {
        data: "=",
		onSuccess: "<",
	},
});

app.controller("progressNoteFormController", [
	"$scope",
	"$filter",
	"ProgressNoteAPI",
	"Base64",
	"$modal",
	"Session",
	"CurrentPatient",
	"countryConfig",
	"$timeout",
	"PROGRESS_NOTE_TYPE",
	"standingOrderService",
	"MedicationAPI",
	"AppointmentAPI",
	function ($scope, $filter, ProgressNoteAPI, Base64, $modal, Session, CurrentPatient, countryConfig, $timeout, PROGRESS_NOTE_TYPE, standingOrderService, MedicationAPI, AppointmentAPI) {
		$scope.PNAPI = ProgressNoteAPI;
		$scope.today = $filter("date")(new Date(), "dd-MMMM-yyyy");
		$scope.Base64 = Base64;
		$scope.practiceName = Session.practice.name;
		$scope.isDHBPublic = Session.practice.type === 'DHB_PUBLIC';
		$scope.CP = CurrentPatient; 
		$scope.createProgressNoteOption = {};
		$scope.isSubmitting = false;
		$scope.createProgressNoteOption.sendHL7ToGP = (Session && Session.practice && Session.practice.practiceFeatures && Session.practice.practiceFeatures.progressNoteSettings && Session.practice.practiceFeatures.progressNoteSettings.send_hl7_to_gp) ? 'true' : 'false';
		$scope.progress_note_type_options = PROGRESS_NOTE_TYPE;
		$scope.countryConfig = countryConfig;
		$scope.transcriptionEnabled = countryConfig.transcriptionFeatureEnabled;

		$scope.progress_note_type_options = PROGRESS_NOTE_TYPE.filter(t => Session.canWriteNoteType(t.value));

		// The clinician a surgery waitlist entry is for: the note's author unless someone else is chosen, from
		// the practice's clinicians as the calendar lists them. The author is the empty choice, so they are not
		// listed twice.
		$scope.authorName = [Session.user.firstName, Session.user.lastName].filter(Boolean).join(" ");
		$scope.waitlistClinicians = [];
		AppointmentAPI.getAppointmentUsers(Session.practice.id).then(function (resp) {
			$scope.waitlistClinicians = (resp.data || [])
				.filter(u => u.id !== Session.user.id)
				.map(u => ({ id: u.id, name: [u.firstName, u.lastName].filter(Boolean).join(" ") }))
				.sort((a, b) => a.name.localeCompare(b.name));
		}, angular.noop);

		function transformDate(value) {
			// dd/MM/yyyy
			const array = value.split('/');
			return array[2] + '-' + array[1] + '-' + array[0];
		}

		$scope.onProgressNoteTypeChange = function () {
			if ($scope.$ctrl.data.progress_note_type == "ADMIN_NOTE" || $scope.$ctrl.data.progress_note_type == "NURSE_NOTE") {
				$scope.$ctrl.data.is_soap_format = false;
				$scope.$ctrl.data.security_level = "PRACTICE";
			}
		}

		// Wrapped in an object rather than held as bare scope properties: the standing order controls sit
		// inside an ng-if, so a primitive ng-model would be written to the child scope and the resets in
		// addStandingOrder() would never reach the controls.
		$scope.standingOrder = { selected: null, laterality: null, options: [], loading: false, error: null };
		$scope.standingOrderLateralityOptions = standingOrderService.LATERALITY_OPTIONS;

		function loadStandingOrderMedications() {
			if ($scope.standingOrder.options.length || $scope.standingOrder.loading) {
				return;
			}
			$scope.standingOrder.loading = true;
			MedicationAPI.getStandingOrderMedicationOptions().then(function (resp) {
				$scope.standingOrder.options = standingOrderService.normaliseOptions(resp.data);
			}, function (error) {
				// Non-fatal: the nurse can still write the note by hand, so degrade quietly rather than
				// throwing a modal over the compose form.
				console.error("Failed to load standing order medications", error && error.status);
				$scope.standingOrder.options = [];
			}).then(function () {
				$scope.standingOrder.loading = false;
			});
		}

		// Changing the medication clears any eye already chosen: an eye picked for the previous medication
		// must never carry over onto a different one.
		$scope.onStandingOrderMedicationChange = function () {
			$scope.standingOrder.laterality = null;
			$scope.standingOrder.error = null;
		};

		// Drives ng-disabled on the "Add to note" button, so the nurse cannot record an ocular medication
		// without stating which eye.
		$scope.isStandingOrderIncomplete = function () {
			const selected = $scope.standingOrder.selected;
			if (!selected) {
				return true;
			}
			return standingOrderService.isLateralityMissing(selected, $scope.standingOrder.laterality);
		};

		$scope.addStandingOrder = function () {
			const selected = $scope.standingOrder.selected;
			const laterality = $scope.standingOrder.laterality;

			// Belt and braces alongside the disabled button - an ocular standing order must record an eye.
			if (!selected || standingOrderService.isLateralityMissing(selected, laterality)) {
				$scope.standingOrder.error = "Select which eye the medication was administered to.";
				return;
			}

			const line = standingOrderService.buildAdministeredLine(selected, laterality);
			const currentLength = standingOrderService.plainTextLength($scope.$ctrl.data.free_text);

			// The editor only enforces max-length for user-typed changes, so a programmatic append is not
			// trimmed here - but the nurse's next keystroke would silently delete the overflow, taking the
			// standing order line with it. Refuse up front instead.
			if (currentLength + line.length + 1 > standingOrderService.FREE_TEXT_MAX_LENGTH) {
				$scope.standingOrder.error = "This note is too long to add another standing order.";
				return;
			}
			$scope.standingOrder.error = null;

			if (!$scope.$ctrl.data.standing_order_medications) {
				$scope.$ctrl.data.standing_order_medications = [];
			}
			// A systemic medication must send no laterality at all - the backend rejects an eye on one.
			$scope.$ctrl.data.standing_order_medications.push({
				medication: selected.name,
				laterality: selected.requiresLaterality ? laterality : null,
			});

			// NURSE_NOTE forces is_soap_format = false, so the free_text editor is already mounted and
			// listening - no need for the two-stage $timeout that insertIntoQuill() uses when coming
			// out of SOAP mode.
			$scope.$broadcast("editor:append-html", {
				editorId: "free_text",
				html: standingOrderService.buildAdministeredHtml(selected, laterality),
			});

			// Reset so the placeholder returns and the same medication can be added again for the other eye.
			$scope.standingOrder.selected = null;
			$scope.standingOrder.laterality = null;
		};

		// _buildEmptyProgressNote() already defaults nurses to NURSE_NOTE without firing ng-change, so the
		// initial load cannot rely on the change handler. A watch rather than a check in the controller
		// body because AngularJS 1.6 does not pre-assign bindings: $ctrl.data is still undefined here.
		$scope.$watch("$ctrl.data.progress_note_type", function (progressNoteType) {
			if (progressNoteType === "NURSE_NOTE") {
				loadStandingOrderMedications();
			}
		});

		$scope.isButtonDisabled = function() {
			// Keep the button disabled while a save is in flight so the note can't
			// be created twice by a double click.
			if ($scope.isSubmitting) {
				return true;
			}

			let val = false;
			if ($scope.$ctrl.data.progress_note_type != "ADMIN_NOTE" && $scope.$ctrl.data.progress_note_type != "NURSE_NOTE") {
				if (!$scope.$ctrl.data.follow_up_type) {
					return true;
				}
				if ($scope.$ctrl.data.is_soap_format) {
					val = !$scope.$ctrl.data.subjective_note && !$scope.$ctrl.data.objective_note && !$scope.$ctrl.data.assessment_note && !$scope.$ctrl.data.plan_note;
				} else {
					val = !$scope.$ctrl.data.free_text;
				}


				// Booking the patient for surgery creates a surgery waitlist entry out of this section, so
				// what it needs is checked here rather than left to the waitlist to cope with.
				//
				// Each of these returns rather than assigning to `val`. Assigning is what let a complete
				// timeframe clear an *empty note body*: the checks below overwrote the emptiness result
				// instead of adding to it, so filling in a timeframe made a blank note saveable.
				if ($scope.$ctrl.data.booked_for_surgery_section.booked_for_surgery) {
					// The timeframe option chosen has to actually carry its value. A waitlist entry that
					// says "in N weeks" with no N, or "between two dates" with no dates, cannot be
					// scheduled from.
					if (!$scope.hasRequiredTimeframe()) {
						return true;
					}

					// The waitlist board draws one row per eye that has a primary procedure, so an entry
					// with neither is written but can never be seen, opened or actioned - it is only
					// reachable in the database. Block it at the point it is created.
					if (!$scope.hasPrimaryProcedure()) {
						return true;
					}
				}

				if (!val) {
					return $scope.$ctrl.data.follow_up_type === 'OTHER' && $scope.$ctrl.data.follow_up_date == null;
				}

				return val;
			} else {
				return !$scope.$ctrl.data.free_text;
			}
		}

		// Whether the chosen preferred-timeframe option has the value it needs. ASAP needs nothing; the
		// other two are meaningless without theirs. No option chosen is not checked here - it leaves the
		// waitlist entry without a preference, which is incomplete but still usable.
		//
		// The option values must match the radios in progressNoteForm.html and the branches in $scope.save
		// - they read WEEKS and DATES. This check previously tested for "WEEK" and "RANGE", which nothing
		// ever sets, so it never once fired.
		$scope.hasRequiredTimeframe = function () {
			const body = $scope.$ctrl.data && $scope.$ctrl.data.booked_for_surgery_section;
			if (!body) {
				return true;
			}
			if (body.preferred_timeframe_type === "WEEKS") {
				return !!body.timeframe_number_of_weeks;
			}
			if (body.preferred_timeframe_type === "DATES") {
				return !!(body.timeframe_after_date && body.timeframe_before_date);
			}
			return true;
		};

		// Whether a primary procedure has been recorded for either eye. Also drives the message under the
		// procedure boxes, so what blocks the save and what explains it cannot drift apart.
		$scope.hasPrimaryProcedure = function () {
			const body = $scope.$ctrl.data && $scope.$ctrl.data.booked_for_surgery_section;
			return !!(body && (body.primary_procedure_od || body.primary_procedure_os));
		};

		// Changing the operative eye hides the other eye's procedure boxes, so drop what was chosen
		// there - otherwise an OS booking would still be saved with an OD procedure (or vice versa).
		$scope.$watch("$ctrl.data.booked_for_surgery_section.laterality", function (newValue, oldValue) {
			const body = $scope.$ctrl.data && $scope.$ctrl.data.booked_for_surgery_section;
			if (!body || newValue === oldValue) {
				return;
			}
			if (newValue === "OS") {
				body.primary_procedure_od = null;
				if (body.secondary_procedure_list) {
					body.secondary_procedure_list = body.secondary_procedure_list.filter(t => t.laterality !== "OD");
				}
			} else if (newValue === "OD") {
				body.primary_procedure_os = null;
				if (body.secondary_procedure_list) {
					body.secondary_procedure_list = body.secondary_procedure_list.filter(t => t.laterality !== "OS");
				}
			}
		});

		$scope.primaryProcedureODCallback = function(form){
			if(form && form.diagnosis_object){
				$scope.$ctrl.data.booked_for_surgery_section.primary_procedure_od = {
					snomed_concept: {
						concept_id: form.diagnosis_object.concept_id,
						fsn: form.diagnosis_object.fsn,
						pt: form.diagnosis_object.pt,
					},
					laterality: "OD",
				}
			}else{
				$scope.$ctrl.data.booked_for_surgery_section.primary_procedure_od = null;
			}
		}

		$scope.primaryProcedureOSCallback = function(form){
			if (form && form.diagnosis_object) {
				$scope.$ctrl.data.booked_for_surgery_section.primary_procedure_os = {
					snomed_concept: {
						concept_id: form.diagnosis_object.concept_id,
						fsn: form.diagnosis_object.fsn,
						pt: form.diagnosis_object.pt,
					},
					laterality: "OS",
				};
			} else {
				$scope.$ctrl.data.booked_for_surgery_section.primary_procedure_os = null;
			}
		}

		$scope.secondaryProcedureODCallback = function(form){
			if(!$scope.$ctrl.data.booked_for_surgery_section.secondary_procedure_list){
				$scope.$ctrl.data.booked_for_surgery_section.secondary_procedure_list = [];
			}
			const os = $scope.$ctrl.data.booked_for_surgery_section.secondary_procedure_list.filter(t=>t.laterality === 'OS');
			if (form) {
				const array = form.map((t) => ({
					snomed_concept: {
						concept_id: t.concept_id,
						fsn: t.fsn,
						pt: t.pt,
					},
					laterality: "OD",
				}));
				$scope.$ctrl.data.booked_for_surgery_section.secondary_procedure_list = [...array,...os];
			}
		}

		$scope.secondaryProcedureOSCallback = function(form){
			if(!$scope.$ctrl.data.booked_for_surgery_section.secondary_procedure_list){
				$scope.$ctrl.data.booked_for_surgery_section.secondary_procedure_list = [];
			}
			const od = $scope.$ctrl.data.booked_for_surgery_section.secondary_procedure_list.filter(t=>t.laterality === 'OD');
			if (form) {
				const array = form.map((t) => ({
					snomed_concept: {
						concept_id: t.concept_id,
						fsn: t.fsn,
						pt: t.pt,
					},
					laterality: "OS",
				}));
				$scope.$ctrl.data.booked_for_surgery_section.secondary_procedure_list = [...array,...od];
			}
		}
        // dd/mm/yyyy to yyyy-mm-dd
		$scope.convertDate = function (date) {
			if(date){
				const array = date.split('/');
				return new Date(array[2] + '-' + array[1] + '-' + array[0]).toString();
			}
			return new Date().toString();
		}

		$scope.onAutomationTaskChange = function(event) {
			if(event.type === 'surgery_waitlist_automation_settings'){
				$scope.createProgressNoteOption.addAutoTaskWaitlist = event.isAutomationTaskEnabled;
			}else if(event.type === 'progress_note_automation_settings'){
				$scope.createProgressNoteOption.addAutoTaskProgressNote = event.isAutomationTaskEnabled;
			}
		}

		$scope.isSendToGpAvailable = function () {
			if ($scope.CP.patient && $scope.CP.patient.practitioners) {
				if ($scope.CP.patient.practitioners.length > 0) {
					if ($scope.CP.patient.practitioners[0].organisation && ($scope.CP.patient.practitioners[0].organisation.edi || $scope.CP.patient.practitioners[0].organisation.email)) {
						return true;
					}
				}
			}
			return false;
		}

		$scope.insertIntoQuill = function (text) {
			if (!text) return;

			var wrappedText = '<div class="ai-inserted">' + text + '</div>';

			$timeout(function () {
				var wasSoap = $scope.$ctrl.data.is_soap_format;

				// Force the form into free text mode
				$scope.$ctrl.data.is_soap_format = false;

				var executeInsertion = function () {
					$scope.$broadcast('editor:insert-html', {
						editorId: 'free_text',
						html: wrappedText
					});
				};

				if (wasSoap) {
					// Give the richtext-editor component time to fully mount and initialize its listeners
					$timeout(executeInsertion, 200);
				} else {
					// If it was already in free text, it's already listening, so insert immediately
					executeInsertion();
				}
			});
		};

		$scope.submit = function () {
			// Guard against double submission: ignore further clicks while a save is
			// in flight (isButtonDisabled() also disables the button until it resolves).
			if ($scope.isSubmitting) {
				return;
			}

			// Make sure that we can actually send to GP. The option is hidden where the country has no
			// send-to-GP feature (AU), so a practice default must not send one silently there either.
			if (!$scope.isSendToGpAvailable() || !countryConfig.sendProgressNoteToGpFeatureEnabled) {
				$scope.createProgressNoteOption.sendHL7ToGP = "false";
			}

			const data = {
				...$scope.$ctrl.data,
				date_of_consult: transformDate($scope.$ctrl.data.date_of_consult),
				time_of_consult: $filter("date")(new Date($scope.$ctrl.data.time_of_consult), "HH:mm:ss"),
				date_of_entry: transformDate($scope.$ctrl.data.date_of_entry),
				time_of_entry: $filter("date")(new Date($scope.$ctrl.data.time_of_entry), "HH:mm:ss"),
				free_text: $scope.Base64.encode($scope.$ctrl.data.free_text),
				subjective_note: $scope.Base64.encode($scope.$ctrl.data.subjective_note),
				objective_note: $scope.Base64.encode($scope.$ctrl.data.objective_note),
				assessment_note: $scope.Base64.encode($scope.$ctrl.data.assessment_note),
				plan_note: $scope.Base64.encode($scope.$ctrl.data.plan_note),
			}

			// Only nurse notes carry standing orders (and only they can be signed off).
			if (data.progress_note_type !== "NURSE_NOTE") {
				delete data.standing_order_medications;
			}

			if (data.booked_for_surgery_section.booked_for_surgery) {
				// Copy so the edits below don't change the live form if the save fails.
				data.booked_for_surgery_section = angular.copy(data.booked_for_surgery_section);
				const body = data.booked_for_surgery_section;
				body.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
				// No clinician chosen: the server makes the note's author the clinician
				if (body.clinician_user_id == null) {
					delete body.clinician_user_id;
				}
				if (body.preferred_timeframe_type === "ASAP") {
					delete body.timeframe_number_of_weeks;
					delete body.timeframe_before_date_UTC;
					delete body.timeframe_after_date_UTC;
				} else if (body.preferred_timeframe_type === "WEEKS") {
					delete body.timeframe_before_date_UTC;
					delete body.timeframe_after_date_UTC;
					// delete body.preferred_timeframe_type;
				} else if (body.preferred_timeframe_type === "DATES") {
					delete body.timeframe_number_of_weeks;
					// delete body.preferred_timeframe_type;
					
					body.timeframe_before_date_UTC = moment.utc(transformDate(body.timeframe_before_date)).toDate().toISOString();
					body.timeframe_after_date_UTC = moment.utc(transformDate(body.timeframe_after_date)).toDate().toISOString();
				}
			} else {
				data.booked_for_surgery_section = { booked_for_surgery: false };
			}
            
			$scope.isSubmitting = true;
			$scope.PNAPI.isProcessing = true;
			$scope.PNAPI.createProgressNote(data, $scope.createProgressNoteOption).then(function (resp) {
				$scope.$ctrl.onSuccess();
				$scope.$emit("waitlist:query");
				// $scope.$broadcast('trigger:automation-task');
			}, function (error) {
				$scope.serverErrorModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
					show: true,
					title: "CatTrax has encountered an error",
				});
			}).then(function () {
				$scope.PNAPI.isProcessing = false;
				$scope.isSubmitting = false;
			})
		}
	},
]);
